import throttle from 'lodash/throttle';
import {Component} from 'panel';

import {replaceByIndex} from '../../../../util/array';

export class BuilderPaneBase extends Component {
  constructor() {
    super(...arguments);
    this.updateRenderedSize = throttle(this._updateRenderedSize, 200, {leading: true});
  }

  get config() {
    return {
      useShadowDom: true,
      helpers: {
        clickedBackButton: () => this.previousPane(),
        clickedCloseButton: () => this.dispatchEvent(new CustomEvent(`change`, {detail: {closed: true}})),
        getBuilderState: () => this.builderState,
        numPanes: () => this.builderState.panes.length,
        updateRenderedSize: () => this.updateRenderedSize(),
        updateRenderedSizeOnNextFrame: () => requestAnimationFrame(() => this.updateRenderedSize()),
        updateActiveIndex: (activeIdx) => this.updateBuilder({activeIdx}),
      },
    };
  }

  // Pane Helpers

  dispatchBubbledEvent(name, value) {
    this.dispatchEvent(new CustomEvent(name, {detail: {value}, bubbles: true, composed: true}));
  }

  nextPane(componentName) {
    this.updateBuilder({panes: this.builderState.panes.concat({componentName})});
  }

  previousPane() {
    this.updateBuilder({panes: this.builderState.panes.slice(0, -1)});
  }

  _updateRenderedSize() {
    // function behind this.updateRenderedSize() that is throttled on component init
    const builderPaneEl = this.el.querySelector(`.builder-pane-base`);
    const {width, height} = (builderPaneEl && builderPaneEl.getBoundingClientRect()) || {};
    if (width || height) {
      const pane = this.builderState.panes[this.paneIdx];
      if (pane && (pane.width !== width || pane.height !== height)) {
        this.updateBuilder({panes: replaceByIndex(this.builderState.panes, this.paneIdx, {...pane, width, height})});
      }
    }
  }

  updateCurrentBuilderPane(attrs) {
    const pane = this.currentPane;
    if (pane) {
      this.updateBuilder({panes: [...this.builderState.panes.slice(0, -1), {...pane, ...attrs}]});
    }
  }

  // Attr Helpers

  get paneIdx() {
    return this.getNumberAttribute(`pane-index`);
  }

  // Builder State

  get builderState() {
    return this.app.state[this.builderStateReference];
  }

  get builderStateReference() {
    const builderStateReference = this.app.builderStateReference;
    if (!builderStateReference) {
      throw new Error(`builderStateReference must be declared`);
    }
    return builderStateReference;
  }

  get currentPane() {
    const panes = this.builderState.panes;
    return panes[panes.length - 1];
  }

  getCurrentPaneAttr(attr) {
    return this.currentPane && this.currentPane[attr];
  }

  updateBuilder(attrs = {}) {
    this.update({[this.builderStateReference]: {...this.builderState, ...attrs}});
  }
}
